/** 作成に成功したときだけ、そのオブジェクトを単独選択にする。 */
export function selectCreatedObject(
  created: { readonly id: string } | null,
  setSelectedObjectIds: (ids: readonly string[]) => void
): void {
  if (!created) return;
  setSelectedObjectIds([created.id]);
}
